import React, { useState, useEffect } from 'react';
import { endpoint } from '../components/API/endpoint';
import LoadingBackdrop from '../components/LoadingBackdrop';

export default function ShopifyAppInstall() {
  const [loading, setLoading] = useState(false);

  async function handleAppInstall() {
    setLoading(true);
    window.location.href = `${endpoint}/v1/shopify-callbacks/auth/login${window.location.search}`;
    setLoading(false);
  }

  useEffect(() => {
    handleAppInstall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <LoadingBackdrop open={loading} />
    </div>
  );
}
